<div class="layout-col full">
  <elder-table
    class="flex"
    matSort
    [data]="groupedEdges$ | async"
    [idField]="'source'"
    (itemClick)="openDetailDialog($event)"
  >
    <elder-data-toolbar
      *elderTableToolbar
      (requestNew)="openCreateDialog()"
      [canRemove]="false"
      [canAdd]="true"
      [canMore]="false"
    >
    </elder-data-toolbar>

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 30px"></th>
      <td mat-cell *matCellDef="let row">
        <mat-icon>link</mat-icon>
      </td>
    </ng-container>

    <!-- number Column -->
    <ng-container matColumnDef="number">
      <th
        mat-header-cell
        *matHeaderCellDef
        style="width: 10%"
        mat-sort-header="source.workCenter.number"
      >
        {{ 'context.number' | translate }}
      </th>
      <td mat-cell *matCellDef="let gEdge">{{ gEdge?.source?.workCenter?.number }}</td>
    </ng-container>

    <!-- name Column -->
    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef
        style="width: 20%"
        mat-sort-header="source.workCenter.name"
      >
        {{ 'context.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let gEdge">{{ gEdge?.source?.workCenter?.name }}</td>
    </ng-container>

    <!-- target nodes Column -->
    <ng-container matColumnDef="target-node">
      <th mat-header-cell *matHeaderCellDef style="width: 50%">
        {{ 'layout.targets' | translate }}
      </th>
      <td mat-cell *matCellDef="let gEdge">
        <mat-chip-set>
          @for (gEdgeTarget of gEdge.targets; track gEdgeTarget) {
            <mat-chip highlighted>
              {{ getLabels(gEdgeTarget) }}
            </mat-chip>
          }
        </mat-chip-set>
      </td>
    </ng-container>
  </elder-table>
</div>
